import { EnumColor } from '@40seas/frontend/common/providers';
import { AiprizeCopmanyStatus } from '@40seas/entities/aiprize';

export const AiprizeCompanyStatusColorMapping = {
    [AiprizeCopmanyStatus.Pending]: 'default',
    [AiprizeCopmanyStatus.Completed]: 'success',
    [AiprizeCopmanyStatus.InProgress]: 'info',
    [AiprizeCopmanyStatus.Failed]: 'error',
} as { [key in AiprizeCopmanyStatus]: EnumColor };
